module.exports = __webpack_public_path__ + "static/media/icon-email.072f099f.svg";